/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 15, height = 18.95 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 20"
    fill="currentColor"
  >
    <path
      fill="currentColor"
      d="M7.425 10.4249H8.575V5.4749H7.425V10.4249ZM8 13.3499C8.2 13.3499 8.36667 13.2874 8.5 13.1624C8.63333 13.0374 8.7 12.8749 8.7 12.6749C8.7 12.4582 8.63333 12.2832 8.5 12.1499C8.36667 12.0166 8.2 11.9499 8 11.9499C7.8 11.9499 7.63333 12.0166 7.5 12.1499C7.36667 12.2832 7.3 12.4582 7.3 12.6749C7.3 12.8749 7.36667 13.0374 7.5 13.1624C7.63333 13.2874 7.8 13.3499 8 13.3499ZM8 19.4749C5.83333 18.8749 4.04167 17.5791 2.625 15.5874C1.20833 13.5957 0.5 11.3916 0.5 8.9749V3.3249L8 0.524902L15.5 3.3249V8.9749C15.5 11.3916 14.7917 13.5957 13.375 15.5874C11.9583 17.5791 10.1667 18.8749 8 19.4749ZM8 18.2749C9.86667 17.6749 11.3958 16.5082 12.5875 14.7749C13.7792 13.0416 14.375 11.1082 14.375 8.9749V4.1249L8 1.7249L1.625 4.1249V8.9749C1.625 11.1082 2.22083 13.0416 3.4125 14.7749C4.60417 16.5082 6.13333 17.6749 8 18.2749Z"
    />
  </svg>
);

export default SvgComponent;
